import { setPmaData, setUserPmaData, setOnboardingPmaData } from "./slice";

export const setPma = (data) => (dispatch) => {
  dispatch(setPmaData(data));
};

export const setUserPma = (data) => (dispatch) => {
  dispatch(setUserPmaData(data));
};

export const setOnboardingPma = (data) => (dispatch) => {
  dispatch(setOnboardingPmaData(data));
};
